import Application from "../../Application";
import withStore, {
  TLoadingAwarePresenter,
  TPresentable
} from "../../core/presenter/withStore";
import { IInstitutionDetails } from "../model/InstitutionDetails";
import { IOrganisation } from "../../organisations/model/Organisation";

export interface TOrganisationDetailsPresenter extends TLoadingAwarePresenter {
  organisation: IOrganisation;
  institutionDetails: IInstitutionDetails;
}

export interface IOrganisationDetailsPresenter
  extends TOrganisationDetailsPresenter,
    TPresentable {
  showCategories(): void;
  showCaseLawDocumentTypes(): void;
  showCaseDecisionTypes(): void;
  showAttachmentTypes(): void;
  loadReferenceValues(institutionDetails: IInstitutionDetails): void;
  loadOrganisation(organisation: IOrganisation): void;
  showLegalViewTypes(): void;
}

const defaultState: TOrganisationDetailsPresenter = {
  organisation: {} as IOrganisation,
  institutionDetails: {} as IInstitutionDetails
};

const OrganisationDetailsPresenter = withStore<
  IOrganisationDetailsPresenter,
  TOrganisationDetailsPresenter
>(
  ({
    application,
    store,
    loader,
    translate
  }): IOrganisationDetailsPresenter => {
    const _store = store;
    const _application: Application = application;
    const state = _store.getState<
      TOrganisationDetailsPresenter & TLoadingAwarePresenter
    >();
    const loadOrganisation = (organisation: IOrganisation) => {
      _store.update({
        organisation,
        breadCrumb: {
          id: () => organisation?.name
        }
      });
    };
    const loadReferenceValues = (institutionDetails: IInstitutionDetails) => {
      _store.update({
        institutionDetails
      });
    };

    const showCategories = () => {
      const { organisation } = _store.getState<TOrganisationDetailsPresenter>();
      return _application.navigator.push({
        pathname: `/organisations/${organisation.id}/categories`
      });
    };
    const showAttachmentTypes = () => {
      const { organisation } = _store.getState<TOrganisationDetailsPresenter>();
      return _application.navigator.push({
        pathname: `/organisations/${organisation.id}/attachment-type`
      });
    };
    const showCaseLawDocumentTypes = () => {
      const { organisation } = _store.getState<TOrganisationDetailsPresenter>();
      return _application.navigator.push({
        pathname: `/organisations/${organisation.id}/case-law-document-type`
      });
    };
    const showCaseDecisionTypes = () => {
      const { organisation } = _store.getState<TOrganisationDetailsPresenter>();

      return _application.navigator.push({
        pathname: `/organisations/${organisation.id}/case-decision-type`
      });
    };
    const showLegalViewTypes = () => {
      const { organisation } = _store.getState<TOrganisationDetailsPresenter>();

      return _application.navigator.push({
        pathname: `/organisations/${organisation.id}/legal-view-type`
      });
    };

    return {
      ...state,
      store: _store,
      loader,
      application: _application,
      translate,
      showCategories,
      loadReferenceValues,
      showAttachmentTypes,
      showCaseLawDocumentTypes,
      loadOrganisation,
      showCaseDecisionTypes,
      showLegalViewTypes
    };
  },
  defaultState
);

export default OrganisationDetailsPresenter;
